module.exports = __webpack_public_path__ + "img/46.9359c8c3.png";